import {Record} from 'immutable';

const NotificationSettings = Record({
    notificationOrigin: undefined,
    PUSH: null,
    PUSH_CHECKED_IN: null,
    EMAIL: null,
    FAMLY_NOTIFICATION: null,
    SMS: null,
});

function fromAPI(data) {
    return new NotificationSettings(data);
}

export default {
    record: NotificationSettings,
    default: new NotificationSettings(),
    fromAPI,
};
